import React from "react";
import AccountOrders from "../../account/AccountOrders";
import { Container, Row, Col } from 'react-bootstrap';
import RetailGuestForm from "./RetailGuestForm";
import Wrapper from "../../wrapper/Wrapper";
import { connect, ReactReduxContext } from 'react-redux';
export var ReturnsViewMarkup = function ReturnsViewMarkup(props) {
  var _props$orders = props.orders,
      orders = _props$orders === void 0 ? [] : _props$orders;
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      padding: "medium",
      background: "default"
    }
  }, /*#__PURE__*/React.createElement(Container, null, Array.isArray(orders) && orders.length ? /*#__PURE__*/React.createElement(AccountOrders, {
    isGuest: true
  }) : /*#__PURE__*/React.createElement(RetailGuestForm, props)));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _state$account2;

  return {
    orders: (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.orders,
    isLoading: (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : _state$account2.loading,
    isError: state.error.isError,
    err: state.error.err
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    postGuestOrderCheck: function postGuestOrderCheck(orderObj) {
      return dispatch(accountOperations.guestOrderCheck(orderObj));
    }
  };
};

export var ReturnsView = connect(mapStateToProps, mapDispatchToProps)(ReturnsViewMarkup);